// SDEV-FILE
// Copyright (c) 2026 SDEV. All rights reserved.
// Workspace: clientside
// File: bedrock.reflections.js
// Created: 2026-03-13T17:40:12.331Z

/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

import Bedrock from "@/reflection/Core/Bedrock.vue"


import Card from "@/framework/component/Card/Card.vue"
import Modal from "@/framework/component/Modal/Modal.vue"
import Table from "@/framework/data-structure/Table/Table.vue"
import Form from "@/framework/interaction/Form/Form.vue"
import Item from "@/framework/navigation/Item/Item.vue"
import Section from "@/framework/navigation/Section/Section.vue"

import Sidebar from "@/framework/layout/Sidebar/Sidebar.vue"
import SidebarNavigation from "@/framework/layout/Sidebar/SidebarNavigation.vue"
import SidebarOverlay from "@/framework/layout/Sidebar/SidebarOverlay.vue"
import SidebarRuntime from "@/framework/layout/Sidebar/SidebarRuntime.vue"
import Systembar from "@/framework/layout/Systembar/Systembar.vue"
import Topbar from "@/framework/layout/Topbar/Topbar.vue"
import PageHeader from "@/framework/layout/Page/PageHeader.vue"
import PageTabs from "@/framework/layout/Page/PageTabs.vue"
import PageContent from "@/framework/layout/Page/PageContent.vue"
import PageFooter from "@/framework/layout/Page/PageFooter.vue"
import EmptyState from "@/framework/state/EmptyState/EmptyState.vue"
import BaseIcon from "@/framework/ui/BaseIcon.vue"
import BaseButton from "@/framework/ui/BaseButton.vue"
import EntityOverview from "../framework/entity/EntityOverview.vue"
import EntityCreate from "../framework/entity/EntityCreate.vue"
import EntityInspect from "../framework/entity/EntityInspect.vue"
import EntityHistory from "../framework/entity/EntityHistory.vue"
import BasePage from "@/framework/layout/Page/BasePage.vue"
import CoreViewTemplate from "@/reflection/Core/CoreViewTemplate.vue"
import WizardViewTemplate from "@/reflection/Core/WizardCoreTemplate.vue"
import WizardView from "@/reflection/Core/wizard/WizardView.vue"
import WizardPreview from "@/reflection/Core/wizard/WizardPreview.vue"
import WizardTemplateSelect from "@/reflection/Core/wizard/WizardTemplateSelect.vue"
import WizardStep from "@/reflection/Core/wizard/WizardStep.vue"
import DiscoveryCoreTemplate from "@/reflection/Core/DiscoveryCoreTemplate.vue"
import DiscoveryView from "@/reflection/Core/discover/DiscoveryView.vue"
import DiscoveryStep from "@/reflection/Core/discover/DiscoveryStep.vue"


export const bedrockReflections = {
    BasePage,
    Sidebar,
    SidebarNavigation,
    SidebarOverlay,
    SidebarRuntime,
    Systembar,
    Topbar,
    Bedrock,
    CoreViewTemplate,
    WizardViewTemplate,
    Card,
    Modal,
    Table,
    Form,
    Item,
    Section,
    PageHeader,
    PageTabs,
    PageContent,
    PageFooter,
    EmptyState,
    BaseIcon,
    BaseButton,
    EntityOverview,
    EntityCreate,
    EntityInspect,
    EntityHistory,
    WizardView,
    WizardPreview,
    WizardTemplateSelect,
    WizardStep,
    DiscoveryCoreTemplate,
    DiscoveryView,
    DiscoveryStep
}
